<template>
    <div>
        <autocomplete id="auto" url="###" anchor="unitName" :onShouldGetData="searchUnit" className="form-control"
            label="writer" :on-select="getUnitName" :options="unitNameOptions" initValue="" :onInput="onInput">
        </autocomplete>
    </div>
</template>

<script>
import { axiosServer } from '@/api/judge';
import Autocomplete from 'vue2-autocomplete-js'
require('vue2-autocomplete-js/dist/style/vue2-autocomplete.css')
require('@/css/autocomplete.css')

export default {
    data() {
        return {
            // 单位
            unitNameOptions: [],
            name: this.$route.query.unitName
        }
    },
    props: {
        initValue: null
    },
    components: {
        Autocomplete
    },
    activated() {
        let _this = this
        setTimeout(function () {
            const auto = document.getElementById("auto")

            if (_this.initValue) {
                auto.value = _this.initValue
            }
            else {
                auto.value = ""
            }
        }, 400);
    },
    methods: {
        searchUnit(value) {
            axiosServer({
                url: "svpSupportedUnit/search",
                params: { unitName: value, pageSize: 10, page: 1 },
                type: 'get'
            })
                .then(resp => {
                    if (resp.data.code == 0) {
                        this.unitNameOptions = resp.data.page.list;
                    }
                })
                .catch(e => {
                    this.errorPrompt("依托单位查询失败");
                });
        },
        getUnitName(obj) {
            this.$emit("select", obj)
        },
        onInput(value) {
            this.$emit("onInput", value)
        }
    }
}
</script>